/**
 * Voice Agent Page — OpenAI Realtime API voice conversation
 * Real-time speech-to-speech with noise cancellation
 */

import React from 'react';
import { useVoiceAgent } from '../hooks/useVoiceAgent';
import './VoiceAgentPage.css';

export default function VoiceAgentPage() {
  const {
    connect,
    disconnect,
    isConnected,
    isSpeaking,
    messages,
    noiseLevel,
    error,
  } = useVoiceAgent();

  return (
    <div className="voice-agent-page">
      <header className="va-header">
        <h1 className="va-logo">🎙️ Voice Agent</h1>
        <span className="va-badge">OpenAI Realtime</span>
      </header>

      <main className="va-main">
        <div className="va-orb-container">
          <div
            className={`va-orb ${isConnected ? 'active' : ''} ${isSpeaking ? 'speaking' : ''}`}
            style={{ '--noise': Math.min(100, noiseLevel) + '%' }}
          />
          <p className="va-orb-label">
            {!isConnected ? 'Click to Start' : isSpeaking ? 'AI Speaking...' : 'Listening...'}
          </p>
        </div>

        <div className="va-controls">
          {!isConnected ? (
            <button className="va-btn va-btn-start" onClick={connect}>
              ▶ Start Session
            </button>
          ) : (
            <button className="va-btn va-btn-end" onClick={disconnect}>
              ⏹ End Session
            </button>
          )}
        </div>

        {error && <p className="va-error">{error}</p>}

        <div className="va-noise-meter">
          <div className="va-noise-bar" style={{ width: noiseLevel + '%' }} />
          <span className="va-noise-label">NC Active</span>
        </div>

        <div className="va-transcript">
          <h3>Transcript</h3>
          <div className="va-messages">
            {messages.length === 0 && (
              <p className="va-empty">Speak to start the conversation...</p>
            )}
            {messages.map((m, i) => (
              <div key={i} className={`va-msg va-msg-${m.role}`}>
                <span className="va-msg-role">{m.role === 'user' ? 'You' : 'AI'}</span>
                <span className="va-msg-content">{m.content}</span>
              </div>
            ))}
          </div>
        </div>
      </main>

      <footer className="va-footer">
        <a href="/" className="va-back">← Back to Demo</a>
      </footer>
    </div>
  );
}
